// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@coa/app/core/services/config.service';
import { Group } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/models/groups.response';

@Injectable({
  providedIn: 'root',
})
export class CreateGroupService {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  createGroup(clientId: number, name: string, locationUnitIds: number[]): Observable<Group> {
    const url = `${ this.configService.getConfig().analyticsApi }/dynamic-groups`;
    const body = {
      clientId,
      locationUnitIds,
      name,
      temporary: false,
    };

    return this.httpClient.post<Group>(url, body);
  }
}
